import React, { useCallback, useEffect, useState } from 'react';
import Input from './Input';
import Dropdown from '../../../common/dropdown/Dropdown';
import {
  useGetAllStateWithSterlingBranchMutation,
  useGetStatesMutation,
} from '../../../features/businessRegistration/businessRegistrationSlice';
import { encryptData } from '../../../utils/encryptJson';
import { decryptJson } from '../../../utils/decryptJson';
import { logUserOut } from '../../../utils/logUserOut';
import { toast } from 'react-toastify';
import { TDirectorInfo } from '../../../types';
import Button2 from '../../global/Button2';
import Button from '../../global/Button';
import customToast, { ToastType } from '../../../components_/Toast';

type TProps = {
  shareholders: TDirectorInfo[];
  currentShareholder: number;
  setActiveStage: React.Dispatch<React.SetStateAction<number>>;
  activeStage: number;
  setShareholders: React.Dispatch<React.SetStateAction<TDirectorInfo[]>>;
  isStageTwoComplete: boolean;
};
export const ResidentialDetails = ({
  currentShareholder,
  isStageTwoComplete,
  setActiveStage,
  setShareholders,
  shareholders,
}: TProps) => {
  const [states, setStates] = useState<any[]>([]);
  const [statesApiError, setStatesApiError] = useState(false);
  const [nearestStatesApiError, setNearestStatesApiError] = useState(false);
  const [nearestSterlingStates, setNearestSterlingStates] = useState<any[]>([]);

  const [submitting, setSubmitting] = useState(false);
  const displayErrorMsg = (errorText: string, variable: string) => {
    if (submitting && !variable) {
      return <div className='text-[red] text-[11px]'>{errorText}</div>;
    }
  };
  const [getStates, { isLoading: lgaLoading }] = useGetStatesMutation();
  const [getSterlingBankStates, { isLoading: branchLoading }] =
    useGetAllStateWithSterlingBranchMutation();
  useEffect(() => {
    const handleGetStates = async () => {
      try {
        const body = encryptData({});
        const data = (await getStates(body as any).unwrap()) as any;
        const res = decryptJson(data?.data);
        setStates(res);
      } catch (err: any) {
        logUserOut(err?.status);
        setStatesApiError(true);
      }
    };
    handleGetStates();
  }, []);

  useEffect(() => {
    const handleGetSterlingBankStates = async () => {
      try {
        const body = encryptData({});
        const data = (await getSterlingBankStates(body as any).unwrap()) as any;
        const res = decryptJson(data?.data);
        setNearestSterlingStates(res);
      } catch (err: any) {
        logUserOut(err?.status);
        setNearestStatesApiError(true);
      }
    };
    handleGetSterlingBankStates();
  }, []);

  useEffect(() => {
    if (statesApiError) {
      customToast(
        'An error occured while getting the states, please refresh',
        ToastType.error,
        '',
        10000,
      );
    }
    if (nearestStatesApiError) {
      customToast(
        'An error occured while getting the nearest states a sterling bank branch is located in, please refresh',
        ToastType.error,
        '',
        10000,
      );
    }
  }, [nearestStatesApiError, statesApiError]);

  return (
    <div className='mr-[4vw] h-[100%]'>
      <div>
        <div className='sl:flex w-full sl:gap-[5%]'>
          <div className='sl:w-[45%] mb-4'>
            <h4 className='pb-[5px]'>Street number and name</h4>
            <div className='flex gap-3 '>
              <div className='w-[90px]'>
                <div className='mb-[0]'>
                  <input
                    className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                    value={shareholders[currentShareholder]?.streetNumber}
                    placeholder={'#'}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const shareholders_ = shareholders?.[currentShareholder]
                        ? shareholders
                        : [...shareholders, {} as TDirectorInfo];
                      const shareholder = shareholders_?.map((shareholder, ind) => {
                        if (currentShareholder === ind) {
                          return {
                            ...shareholder,
                            streetNumber: e.target.value,
                          };
                        }
                        return shareholder;
                      });
                      setShareholders(shareholder);
                    }}
                  />
                </div>
              </div>
              <div className='w-full'>
                <div className='mb-[0]'>
                  {/* <label className='flex flex-col relative text-[#212121] '>Business name 1</label> */}
                  <input
                    className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                    value={shareholders?.[currentShareholder]?.streetName}
                    placeholder={'Type street name'}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const shareholders_ = shareholders?.[currentShareholder]
                        ? shareholders
                        : [...shareholders, {} as TDirectorInfo];
                      const shareholder = shareholders_?.map((shareholder, ind) => {
                        if (currentShareholder === ind) {
                          return {
                            ...shareholder,
                            streetName: e.target.value,
                          };
                        }
                        return shareholder;
                      });
                      setShareholders(shareholder);
                    }}
                  />
                </div>
              </div>
            </div>
            {displayErrorMsg(
              'Street number cannot be empty',
              shareholders[currentShareholder]?.streetNumber,
            )}
            {displayErrorMsg(
              'Street name cannot be empty',
              shareholders[currentShareholder]?.streetName,
            )}
          </div>
          <div className='sl:w-[45%] mb-4'>
            <Dropdown
              className='border !border-[#B8C9C9] rounded-[2px] !h-[52px] '
              label='Located State'
              placeholder={''}
              labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
              options={
                states &&
                states.map((state: any) => {
                  return {
                    label: state.name,
                    value: state.name,
                  };
                })
              }
              width='100%'
              isLoading={lgaLoading}
              value={shareholders?.[currentShareholder]?.locatedState}
              setSelectedOption={(e: { value: string; label: string }) => {
                const shareholders_ = shareholders?.[currentShareholder]
                  ? shareholders
                  : [...shareholders, {} as TDirectorInfo];
                const shareholder = shareholders_?.map((shareholder, ind) => {
                  if (currentShareholder === ind) {
                    return {
                      ...shareholder,
                      locatedState: e.value,
                    };
                  }
                  return shareholder;
                });
                setShareholders(shareholder);
              }}
            />

            {displayErrorMsg(
              'Located state cannot be empty',
              shareholders[currentShareholder]?.locatedState,
            )}
          </div>
        </div>

        <div className='sl:flex w-full sl:gap-[5%]'>
          <div className='sl:w-[45%] mb-4'>
            <Dropdown
              className='border !border-[#B8C9C9] rounded-[2px] !h-[52px] '
              label='Local Government Area'
              placeholder={''}
              labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
              options={
                states &&
                states
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  ?.find(
                    (item: any) => item?.name === shareholders?.[currentShareholder]?.locatedState,
                  )
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  ?.lgas?.map((item: any) => {
                    return {
                      label: item,
                      value: item,
                    };
                  })
              }
              width='100%'
              isLoading={lgaLoading}
              value={shareholders?.[currentShareholder]?.lga}
              setSelectedOption={(e: { value: string; label: string }) => {
                const shareholders_ = shareholders?.[currentShareholder]
                  ? shareholders
                  : [...shareholders, {} as TDirectorInfo];
                const shareholder = shareholders_?.map((shareholder, ind) => {
                  if (currentShareholder === ind) {
                    return {
                      ...shareholder,
                      lga: e.value,
                    };
                  }
                  return shareholder;
                });
                setShareholders(shareholder);
              }}
            />
            {displayErrorMsg(
              'Local government cannot be empty',
              shareholders[currentShareholder]?.lga,
            )}
          </div>
          <Input
            label='City or Town'
            value={shareholders?.[currentShareholder]?.cityOrTown}
            style='sl:w-[45%]'
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const shareholders_ = shareholders?.[currentShareholder]
                ? shareholders
                : [...shareholders, {} as TDirectorInfo];
              const shareholder = shareholders_?.map((shareholder, ind) => {
                if (currentShareholder === ind) {
                  return {
                    ...shareholder,
                    cityOrTown: e.target.value,
                  };
                }
                return shareholder;
              });
              setShareholders(shareholder);
            }}
            type='text'
            errorDiv={displayErrorMsg(
              'City or Town cannot be empty',
              shareholders[currentShareholder]?.cityOrTown,
            )}
          />
        </div>
      </div>

      <div className='flex justify-between my-[65px]'>
        <Button
          className='px-2 md:px-5 !py-[10px] !bg-[#768396] text-[11px] text-white border-[0px] rounded-none '
          size='sm'
          underline={false}
          theme='secondary'
          onClick={() => setActiveStage((prev) => prev - 1)}
        >
          PREVIOUS
        </Button>
        <Button2
          className='px-2 md:px-5 !py-[10px] text-[11px] text-white border-[0px] rounded-none '
          size='sm'
          underline={false}
          theme='primary'
          // disabled={!isStageTwoComplete}
          onClick={() => {
            if (isStageTwoComplete) {
              setActiveStage((prev) => prev + 1);
            }
            setSubmitting(true);
          }}
        >
          UPLOAD DOCUMENTS
        </Button2>
      </div>
    </div>
  );
};
